/**
 * @module geo/map/layer
 */

import {Store} from 'redux';

import {AppStore} from '../../store/app';
import {GroupMapEntry as interf} from '../../types/map/layer/group.map.entry';

import {MapEntry} from './map.entry';

export {interf};

/**
 * A group map entry in a layer for map, can contains other map entry.
 */
export class GroupMapEntry extends MapEntry implements interf {
  public static typeDef = 'com.bg.functionality.map.layer.GroupMapEntry';
  public opened: boolean;
  constructor(options: any, store: Store<AppStore>) {
    super(options, store);
    this.opened = options.opened;
  }
}
